"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_setup_1 = require("./store-setup");
var storetypes_1 = require("./storetypes");
exports.setStoreType = function (storeType) {
    if (Object.values(storetypes_1.StoreTypes).includes(storeType)) {
        store_setup_1.SELECTED_STORE.type = storeType;
    }
};
exports.initConfig = function (configJson) {
    store_setup_1.HIVER_CONFIG_STORE().clearAll();
    return store_setup_1.HIVER_CONFIG_STORE().setAll(configJson, true);
};
exports.setAllConfig = function (configJson) {
    return store_setup_1.HIVER_CONFIG_STORE().setAll(configJson, true);
};
exports.getAllConfig = function (keys) {
    if (keys === void 0) { keys = []; }
    return store_setup_1.HIVER_CONFIG_STORE().getAll(keys);
};
exports.setConfigKey = function (key, value) {
    return store_setup_1.HIVER_CONFIG_STORE().set(key, value, true);
};
exports.getConfigKey = function (key) {
    return store_setup_1.HIVER_CONFIG_STORE().get(key);
};
exports.deleteConfig = function (key) {
    return store_setup_1.HIVER_CONFIG_STORE().remove(key);
};
//# sourceMappingURL=storage.js.map